/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.row {
  display: grid;
  gap: calc(var(--spacing, 0.25rem) * 4);
  width: 100%;
  margin-bottom: calc(var(--spacing, 0.25rem) * 4);
}
.form.max-2xl {
  max-width: var(--container-2xl, 42rem);
}
.form.max-3xl {
  max-width: var(--container-3xl, 48rem);
}
.form.max-4xl {
  max-width: var(--container-4xl, 56rem);
}
.form.max-5xl {
  max-width: 1500px;
}
.row[data-columns="1"] {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.row[data-columns="2"] {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.row[data-columns="3"] {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.row[data-columns="4"] {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.row[data-columns="5"] {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.section {
  &:first-child {
    margin-top: 0px;
  }
  margin-top: calc(var(--spacing, 0.25rem) * 6);
}
.formGrid .section {
  margin-top: 0px;
}
.formGrid {
  display: grid;
  gap: calc(var(--spacing, 0.25rem) * 8);
}
.formGrid.columns-2 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
  @media (width >= 80rem) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.formGrid.columns-3 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
  @media (width >= 80rem) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
